import React from 'react'
import styled from 'styled-components'
import { flexRender } from '@tanstack/react-table'

import {
    TABLE_WIDTH_NUMBER_MODIFIER,
    TABLE_WIDTH_PERCENTAGE_MODIFIER,
} from '../..'
import { TableHeader } from '../TableHeader'
import { TableRow } from '../TableRow'

const TableHeadElement = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #ffffff;
`
export const TableHead = ({
  table,
  getRowProps = () => {},
  getHeaderProps = () => {},
  getColumnProps = () => {},
}) => (
    <TableHeadElement className="table-head">
        {table?.getHeaderGroups()?.map((headerGroup, i) => (
            <TableRow key={`${headerGroup.id}_${i}`}>
                {headerGroup?.headers?.map((header, i) => {
                    const columnDef = header.column.columnDef

                    if (columnDef?.header === undefined) {
                        return null
                    }

                    return (
                        <TableHeader
                            justify={header.column.columnDef?.meta?.justify ?? 'left'}
                            key={`${header.id}_${i}`}
                            colSpan={header.colSpan}
                            width={columnDef.size}
                            minWidth={columnDef.minSize ? `${columnDef.minSize}` : '0px'}
                            type={typeof table?.getRowModel()?.rows[0]?.original[header?.id]}
                            canSort={header?.column?.getCanSort()}
                            isSorted={header?.column?.getIsSorted()}
                            isFiltered={header?.column?.getCanFilter()}
                            onClick={header?.column?.getToggleSortingHandler()}
                            getRowProps={() => getRowProps(headerGroup)}
                            column={header?.column}
                            getColumnProps={() =>
                                getColumnProps(header.column.id, header.column)
                            }
                            getHeaderProps={() => getHeaderProps(header)}
                        >
                            {columnDef.isPlaceholder
                                ? null
                                : flexRender(
                                    header.column.columnDef.header,
                                    header.getContext(),
                                )}
                        </TableHeader>
                    )
                })}
            </TableRow>
        ))}
    </TableHeadElement>
)